import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SearchSelect.html?raw';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import _InputMultiBase from '../_InputMultiBase/_InputMultiBase';
import Multiselect from '../Multiselect/Multiselect';
import "../Multiselect/Multiselect";
//import DataItems = require("DataItems");


interface option { value: any, entity: object, optionNode: HTMLElement, optionSelectorNode: HTMLElement, label: string, selected: boolean}

interface optionsHeadingsRegistryObj { optionHeading: string, selectableOptions: object[] }
class SearchSelect extends compose(_InputMultiBase, _LabelInputBase) {
    templateString: any = template;

    labelAttribute: string = null;
    secondaryLabelAttribute: string = null;
    valueAttribute: string = "ID"; // Vorgabewert
    colorAttribute: string = null; // Vorgabewert
    selectableAttribute: string = null; // Vorgabewert
    groupAttribute: string = null;
    private groupValueAttribute: string = null;
    groupColorAttribute: string = null;
    suggestionLabelAttribute: string = null;
    addNonExistentOption: boolean = true;
    cyName: string = null;
    

    private defaultReturnValueType: "string" | "entity" = "string";

    private _multiselectWidget: MdsLax<InstanceType<typeof Multiselect>>;

    //dropDownPositionAbsolute: boolean = true;

    focus() {
        this._multiselectWidget.focus();
    }
    /**
   * Fügt dem Load-Request weitere Parameter hinzu.
   * @name name Name des Parameters
   * @param value Wert des Parameters
   */
    addAdditionalRequestParameter(name: string, value: any): void {
        this.copyAttributesToMultiSelect();
        this._multiselectWidget.addAdditionalRequestParameter(name, value);
    }
    private _setRequestParameterAttr(keyvaluepair: { name: string, value: any }) {
        this.addAdditionalRequestParameter(keyvaluepair.name, keyvaluepair.value);
    }
    setRequestParameter(name: string, value: any): void {
        this.addAdditionalRequestParameter(name, value);
    }

    getAllValues(): object[] {
        return this._multiselectWidget.getAllValues();
    }

    hideBtnShowSelected(bHide: boolean) {
        this._multiselectWidget.hideBtnShowSelected(bHide);
    }

    setOuterPlaceholder(value: string) {
        this._multiselectWidget.setOuterPlaceholder(value);
    }
    _setPlaceholderAttr(value: string, outerPlaceholder?: string): void {
        this._multiselectWidget._setPlaceholderAttr(value, outerPlaceholder);
    }
    setReadonly(bRead: boolean) {
        this._multiselectWidget.setReadonly(bRead);
    }
    setSelectNoneButton(show: boolean) {
        this._multiselectWidget._setIsBtnSelectNoneVisibleAttr(show == true);
        this.setMandatory(this.isMandatory && show != true);
    }
    setMandatory(bSetMandatory: boolean) {
        super.setMandatory.apply(this, arguments as any);

        this._multiselectWidget.setMandatory(this.isMandatory);
    }

    private _setSelectNoneAttr(value: boolean) {
        this.setSelectNoneButton(value);
    }
    private _setAutoselectSingleValueAttr(value: boolean | "strict") {
        this.autosetSingleValue(value);
    }
    /**
 * false: keine automatische Auswahl
 * true: wenn es nur einen Wert in der valuelist gibt, wird dieser gesetzt (mit change-emit)
 * strict: die Dropdownauswahl wird gesperrt, wenn der einzige verfügbare Wert bereits ausgewählt ist
 */

    autosetSingleValue(value: boolean | "strict") {
        this._multiselectWidget.autosetSingleValue(value);
    }
   
    getValue(bReturnEntities?: boolean): any {
        
        
        if (bReturnEntities) {
            let entity = this.getSelectedEntity();
            return entity;
        }

        let strValues = this._multiselectWidget.getValue(false);

        let strValue = null;
        if (strValues?.length) {
            strValue = strValues[0];
        }

        return strValue;
    }
    setValue(value: any, bSuppressChangeEvent: boolean = false): void {
        this._multiselectWidget.setValue(value, bSuppressChangeEvent);
    }

    setAddNonExistentOption(value: boolean): void {
        this._multiselectWidget.setAddNonExistentOption(value);
    }
    setLabel(label: string, searchPlaceholder?: string): void {
        this._multiselectWidget.setLabel(label, searchPlaceholder);
    }

    protected _setLabelPosition(position) {
        this._multiselectWidget.setLabelPosition(position);
    }

    optionExists(value: any): boolean {
        return this._multiselectWidget.optionExists(value);
    }

    setData(presetValue: any,
        valuelist: Array<Object>,
        bSuppressChange?: boolean,
        labelAttribute?: string,
        valueAttribute?: string,
        colorAttribute?: string,
        groupLabelAttribute?: string,
        groupValueAttribute?: string,
        groupColorAttribute?: string) {

        //    }
        //setData(data: any, arrayPropertyName?: string, labelAttributeName?: string, valueAttributeName?: string): void {
        this._multiselectWidget.secondaryLabelAttribute = this.secondaryLabelAttribute;

        this._multiselectWidget.setData(presetValue, valuelist, bSuppressChange, labelAttribute, valueAttribute, colorAttribute, groupLabelAttribute, groupValueAttribute, groupColorAttribute)
}

/**
 * WENN MÖGLICH ABLÖSEN DURCH SETDATA!
 */
    setSelectionListLEGACY(data: any, arrayPropertyName?: string, labelAttributeName?: string, valueAttributeName?: string): void {
        
        this.copyAttributesToMultiSelect();

        let valueList = [];
        if (arrayPropertyName) {
            valueList = lang.clone(data[arrayPropertyName]);
        } else if (lang.isArray(data)) {
            valueList = lang.clone(data);
        }

        this._multiselectWidget.setData(null, valueList, false, labelAttributeName, valueAttributeName)
    }

    getDisplayValue(): string {
        let selectedEntities = this._multiselectWidget.getValue(true);
        let selectedEntity = null;
        if (selectedEntities?.length == 1) {
            selectedEntity = selectedEntities[0];
        }

        if (!selectedEntity) return "";
        return this.PitHelper.getEntityAttributeValue(selectedEntity, this._multiselectWidget.labelAttribute);
    }

    setDropDownPositionAbsolute(bSetAbsolute: boolean) {
        this._multiselectWidget.setDropDownPositionAbsolute(bSetAbsolute);
    }

    /**
    * Für die bestehende Gruppenregistrierung eine Zuweisung von Icons vornehmen.
    * GroupValues und GroupIcons müssen dieselbe Länge aufweisen, dann wird für jede registrierte Gruppe mit dem Wert aus groupValues das jeweilige Icon aus groupIcons hinterlegt.
    */
    setGroupIcons(groupValues: Array<string>, groupIcons: Array<string>) {

        this._multiselectWidget.setGroupIcons(groupValues, groupIcons);
    }
    setOptionsWithColor(values: Array<string>, labels: Array<string>, colors: Array<string> | Array<Partial<more.EntityAPIColor>>, preselectedValue?: string, selectable?: Array<boolean>) {
        this._multiselectWidget.setOptionsWithColor(values, labels, colors, preselectedValue ? [preselectedValue] : null, selectable);
    }
    setOptions(values: Array<string>, labels: Array<string>, preselectedValue?: string, selectable?: Array<boolean>) {
        this._multiselectWidget.setOptions(values, labels, preselectedValue ? [preselectedValue] : null, selectable);
    }

    setOptionGroups(groupLabels: Array<string>, groupValues?: Array<string>, groupColors?: Array<string>, groupIcons?: Array<string>) {
        this._multiselectWidget.setOptionGroups(groupLabels, groupValues, groupColors, groupIcons);
    }

    loadListValues(presetValue?: any, bSuppressChange?: boolean) {
        this.copyAttributesToMultiSelect();

        this._multiselectWidget.loadListValues(presetValue, bSuppressChange);
    }

    /** Durchreicher für _StatefulSection: initialer Listen-Load des inneren MultiSelect noch offen? */
    isInitialListLoadPending(): boolean {
        return this._multiselectWidget ? this._multiselectWidget.isInitialListLoadPending() : false;
    }

    setUrl(newUrl: string) {
        this.copyAttributesToMultiSelect();
        this._multiselectWidget.setUrl(newUrl);
    }

    private _setUrlAttr(url: string): void {
        this.setUrl(url);
    }

    setCallfunction(callfunctionName: string) {
        this.copyAttributesToMultiSelect();
        this._multiselectWidget.setCallfunction(callfunctionName);
    }
    private _setCallfunctionAttr(callfunctionName: string) {
        this.setCallfunction(callfunctionName);
    }

    private _setLabelattributeAttr(attr: string) {
        this._setLabelAttributeAttr(attr);
    }

    private _setLabelAttributeAttr(attr: string) {
        this.labelAttribute = attr;
        this.copyAttributesToMultiSelect();
    }

    private _onChange_Multiselect() {
        
        this._value = this._multiselectWidget["_value"];
        //this.emit("change");
        this.isValid = this._multiselectWidget.isValid;

        this.__delayValueChangeEmit(1);
    }
     private _onLoaded_Multiselect() {
         this.isValid = this._multiselectWidget.isValid;

         this.emit("listValuesLoaded");
         this.emit("loaded");
    }

    protected customValidation(): boolean {
        let previousValid = this.isValid;
        this.isValid = this._multiselectWidget["customValidation"]();
        if (previousValid != this.isValid) this.emit("valid", this.isValid);
        return this._multiselectWidget?.isValid;
    }
    private _setOptionHeadingGroupAttributeAttr(value: string, colorAttribute?: string): void {
        
        this.setOptionHeadingGroupAttribute(value, colorAttribute);
    }
    setOptionHeadingGroupAttribute(value: string, colorAttribute?: string): void {
        this.groupAttribute = value;
        if (typeof (colorAttribute) != "undefined") this.groupValueAttribute = colorAttribute;

        if (this._multiselectWidget) {
            this._multiselectWidget.setOptionHeadingGroupAttribute(value, colorAttribute);
        }
    }
    private _getSelectedEntityAttr(): object {
        return this.getSelectedEntity();
    }
    getSelectedEntity() {
        let selectedEntities = this._multiselectWidget.getValue(true);
        let selectedEntity = null;
        if (selectedEntities?.length == 1) {
            selectedEntity = selectedEntities[0];
        }

        return selectedEntity;
    }

    postMixInProperties() {
        this._multiselectWidget = new Multiselect();
        if (this.cyName) this._multiselectWidget.setCyName(this.cyName);

        this._multiselectWidget.on("valid", lang.hitch(this, this.customValidation));
        this._multiselectWidget.on("change", lang.hitch(this, this._onChange_Multiselect));
        this._multiselectWidget.on("listValuesLoaded", lang.hitch(this, this._onLoaded_Multiselect));
        //this._multiselectWidget.on("loaded", lang.hitch(this, this._onLoaded_Multiselect));

        this._multiselectWidget.setMultiselect(false);


        this.copyAttributesToMultiSelect();
        super.postMixInProperties.apply(this, arguments as any);

    }

    private copyAttributesToMultiSelect() {
        this._multiselectWidget.labelAttribute = this.labelAttribute;
        this._multiselectWidget.secondaryLabelAttribute = this.secondaryLabelAttribute;
        this._multiselectWidget.valueAttribute = this.valueAttribute;
        this._multiselectWidget.selectableAttribute = this.selectableAttribute;
        this._multiselectWidget.colorAttribute = this.colorAttribute;
        this._multiselectWidget.groupAttribute = this.groupAttribute;
        this._multiselectWidget.groupColorAttribute = this.groupColorAttribute;
        this._multiselectWidget.groupValueAttribute = this.groupValueAttribute;
        this._multiselectWidget.addNonExistentOption = this.addNonExistentOption;
    }

    _setIsHideSelectedBtnAttr(bool: boolean): void {
        this.hideBtnShowSelected(bool);
    }

    refreshOptions() {
        this._multiselectWidget.refreshOptions();
    }


    postCreate() {
        this._multiselectWidget.placeAt(this.domNode, "only");
        super.postCreate.apply(this, arguments as any);
       
    }

    startup() {
        super.startup.apply(this, arguments as any);

        this._multiselectWidget.startup();
        this.isValid = this._multiselectWidget.isValid;
    }

    setCyName(cyName: string) {
        this.cyName = cyName;
        if (cyName) this._multiselectWidget?.setCyName(cyName);
    }
}

export default mdsWidget(SearchSelect);